import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

if (window.navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    registrations.forEach(async registration => {
      await registration.unregister();
    });
  });
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
